import React, { useEffect } from "react";
import "./Supporters.css";
import AOS from "aos";
import "aos/dist/aos.css";

import activityVideo from "../../Assets/video.mp4";
import activityVideo1 from "../../Assets/video1.mp4";

const Supporters = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="supporter-section">
      <div className="tittle" data-aos="fade-up">
        <h2 className="supporter-title">Our Activities</h2>
        <div className="supporter-underline"></div>
      </div>

      {/* Video 1 */}
      <div
        className="video-container"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <video className="activity-video" controls playsInline>
          <source src={activityVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Video 2 */}
      <div
        className="video-container"
        data-aos="zoom-in"
        data-aos-delay="400"
      >
        <video className="activity-video" controls playsInline>
          <source src={activityVideo1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default Supporters;